import { Versioning } from "domain/entities/versioning";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { IVersioningRepository } from "domain/contracts/versioning.contract";
import { VersioningInputFilter } from "domain/models/versioning-input-filter";

class VersioningRepository implements IVersioningRepository {

  async create(input: Versioning): Promise<Message<Versioning>> {
    const response = await httpClient.post(`/versioning`, { data: input });
    return response.data;
  }

  async getAll(filter: VersioningInputFilter): Promise<Message<Versioning[]>> {
    const response = await httpClient.get(`/versioning`, { params: filter });
    return response.data;
  }

}

export default new VersioningRepository();
